import { FunctionComponent } from 'react';
import Trans from 'next-translate/Trans';
import { useAppContext } from '../../providers/app-context';

const SEOContent: FunctionComponent<{
  productDetail: any;
}> = ({ productDetail }) => {
  const years = productDetail.car.years
    .replace('[', '')
    .replace(']', '')
    .split('-');
  return (
    <>
      <div className="lg:text-left text-[14px] leading-[24px] max-lg:text-base">
        <div className="container mx-auto max-md:px-4 pt-4 flex flex-col gap-2 text-justify">
          <>
            <Trans
              i18nKey={'product:seo-content'}
              components={{ p: <p /> }}
              values={{
                warranty: productDetail.warranty,
                part: productDetail?.part.name,
                vehicle: `${productDetail?.car.brand_name || ''} 
                  ${productDetail?.car.model_name || ''} 
                  ${productDetail?.car.version_name || ''}`,
                year_init: years.length === 2 ? years[0] : '',
                year_final: years.length === 2 ? years[1] : '',
              }}
            />
          </>
        </div>
      </div>
    </>
  );
};

export default SEOContent;
